import { computed, type Ref } from 'vue'
import { SortName } from '@scayle/storefront-nuxt'
import {
  decideProductListing,
  type ProductListingDecision,
} from './productListingDecision'
import { useNuxtApp } from '#app/nuxt'

import useExperiments from '~/composables/useExperiments'

interface UseProductListingPolicyOptions {
  selectedSort: Ref<{ name?: string } | undefined>
  // ECOM-2669: true when the active category carries a manual sort key
  // (`shopLevelCustomData.sortingKey`) on the default sort. Curated categories
  // must be served deterministically by SAPI, not Odoscope's optimized order.
  hasCustomSort: Ref<boolean>
}

export default ({
  selectedSort,
  hasCustomSort,
}: UseProductListingPolicyOptions) => {
  const { $device } = useNuxtApp()
  const { showOdoscopePlp } = useExperiments()

  return computed<ProductListingDecision>(() =>
    decideProductListing({
      isCrawler: $device.isCrawler,
      isDefaultSort: selectedSort.value?.name === SortName.TOPSELLER,
      hasCustomSort: hasCustomSort.value,
      showOdoscopeExperiment: showOdoscopePlp.value,
    }),
  )
}
